<template>
    <section>
        <div>
            <h1>E-learning UN iLabCC</h1>
        </div>
        <div>
            <p>
                The E-learning section provides access to online courses and self-paced learning resources developed by United Nations entities and partners across the thematic areas covered by UN iLabCC. The section serves as a gateway to learning opportunities available through the United Nations system and its partners on issues related to SDG 16 and the 2030 Agenda.             
            </p>           
        </div>
        <p><b>E-learning by UN iLabCC Category</b></p>
        <v-row>
            <v-col v-for="card in cards2" :key="card.id" cols="12" md="3">
                <router-link :to="{ name: card.component, params: { id: card.id } }" style="text-decoration: none;">
                    <v-card class="mx-auto" max-width="380" min-height="180">  <!-- Cara frontal del card con la imagen y el título -->
                        <div v-if="cardState[card.id] && !cardState[card.id].isFlipped">
                            <v-carousel :show-arrows="false" cycle height="180" hide-delimiters>
                                <v-carousel-item v-for="(image, index) in card.images" :key="index">
                                    <!-- Ajusta el estilo de v-img para cubrir el espacio del v-card -->
                                    <v-img class="align-end text-white" height="100%" :src="getImageSrc(image)" :style="{ 'object-fit': 'cover' }">
                                        <!-- Aplica el color blanco al título del v-card 
                                        <v-card-title style="color: white; font-size: 16px;" >{{ card.title }}</v-card-title>-->
                                    </v-img>
                                </v-carousel-item>
                            </v-carousel>
                        </div>
                        <div>
                            <v-card-title style="color: white; background-color: rgba(26,71,107,1); font-size: 13px; width: 100%; display: flex; justify-content: center; padding-top: 5px; padding-bottom: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                {{ card.title }}
                            </v-card-title>
                        </div>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>
        <br>
        <p><b>E-learning Portals</b></p>
        <v-row>
            <v-col v-for="card in cards" :key="card.id" cols="12" md="3">
                <v-card class="mx-auto" max-width="380" min-height="180" :href="card.link" target="_blank">
                    <!-- Cara frontal del card con la imagen y el título -->
                    <div>
                        <v-carousel :show-arrows="false" cycle height="180" hide-delimiters>
                            <v-carousel-item v-for="(image, index) in card.images" :key="index">
                                <!-- Ajusta el estilo de v-img para cubrir el espacio del v-card -->
                                <v-img class="align-end text-white" height="100%" :src="getImageSrc(image)" :style="{ 'object-fit': 'cover' }">
                                    <!-- Aplica el color blanco al título del v-card 
                                    <v-card-title style="color: rgb(15, 135, 201); font-size: 16px;">{{ card.title }}</v-card-title>
                                    <v-divider class="mx-2 mb-1"></v-divider>-->
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                    </div>
                        <div>
                            <v-card-title style="color: white; background-color: rgba(26,71,107,1); font-size: 13px; width: 100%; display: flex; justify-content: center; padding-top: 5px; padding-bottom: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                {{ card.title }}
                            </v-card-title>
                        </div>
                </v-card>
            </v-col>
        </v-row>
    </section>
</template>

<script>
import NoticiaDetalle from './NoticiaDetalle.vue';
import Publication from './Publication.vue';
import axios from 'axios';

export default {
    components: {
        NoticiaDetalle,
        Publication,
    },
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: '',
                r_images: '',
                link: '',
                folder: '',
            },
            cards: [
                {
                    id: 1,
                    title: 'UNODC Global E-Learning',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['course4.png'], 
                    link: 'https://www.unodc.org/elearning/en/courses/course-catalogue.html',
                },
                {
                    id: 2,
                    title: 'OIM - Course Cataloge',
                    subtitle: 'INEGI',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing',
                    additionalInfo: 'Additional Info for Card 2Additional Info for Card 2Additional Info for CAdditional Info for Card 2Additional Info for Card 2Additional IAdditional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2nfo for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2ard 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2',
                    images: ['course1.png'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://www.ecampus.iom.int/course/index.php?categoryid=17',
                },
                {
                    id: 3,
                    title: 'UNODC - INEGI',
                    subtitle: 'UNESCO',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing',
                    additionalInfo: 'Additional Info for Card 3',
                    images: ['course2.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://www.cdeunodc.inegi.org.mx/index.php/2023/05/09/curso-en-linea-gratuito-la-clasificacion-internacional-delitos-fines-estadisticos-ya-esta-disponible',
                },
                {
                    id: 4,
                    title: 'Info Segura',
                    subtitle: 'UNICEF',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['course3.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://infosegura.org/',
                },
                {
                    id: 5,
                    title: 'Info Segura - All',
                    subtitle: 'Bolivia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing',
                    additionalInfo: 'Additional Info for Card 5',
                    images: ['course3.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://formacion-infosegura.org/course/index.php?categoryid=2',
                },
                {
                    id: 6,
                    title: 'Sherloc',
                    subtitle: 'Bolivia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing',
                    additionalInfo: 'Additional Info for Card 5',
                    images: ['course5.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://sherloc.unodc.org/cld/en/st/home.html',
                },
            ],
            cards2: [
                {
                    id: 1,
                    title: 'Corruption',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['1.png'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                    component: 'CCorruption'
                },
                {
                    id: 2,
                    title: 'Organized Crime',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'COrganizeCrime'
                },
                {
                    id: 3,
                    title: 'Crime Prevention & Criminal Justice (live - NEW)',
                    subtitle: 'INEGI',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2Additional Info for Card 2Additional Info for CAdditional Info for Card 2Additional Info for Card 2Additional IAdditional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2nfo for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2ard 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2',
                    images: ['3.jpg'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'CCrimePrevention'
                },
                {
                    id: 4,
                    title: 'Drugs',
                    subtitle: 'UNICEF',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'CDrugs'
                },
                {
                    id: 5,
                    title: 'Gender-Based Violence',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['5.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'CGender'
                },
                {
                    id: 6,
                    title: 'Prison Reform',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['6.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'CPrison'
                },
                {
                    id: 7,
                    title: 'Violence Against Children (Coming Soon)',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['7.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 9,
                    title: 'Terrorism',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['9.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'CTerrorism'
                },
                {
                    id: 8,
                    title: 'Homicide (live - NEW)',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['8.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'CHomicides'
                },
                // {
                //     id: 10,
                //     title: 'Citizen Security (Coming Soon)',
                //     subtitle: 'Mexico',
                //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                //     additionalInfo: 'Additional Info for Card 7',
                //     images: ['10.jpg'],
                //     chip: ['7:00 AM', '9:00 AM'], 
                //     link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                // },
            ],
            cardState: {},
        };  
    },/*
    mounted() {
      this.listar();
    },*/
    methods: {
        // Obtener la lista de Categiries
        /*async listar() {
            try {
                const response = await axios.get('api/Categories/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        additionalInfo: category.additionalInfo,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                        link: category.link,
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        flipCard(cardId, isFlipped) {
            // Verificar si cardState[cardId] existe antes de acceder a sus propiedades
            if (this.cardState[cardId]) {
                this.$set(this.cardState[cardId], 'isFlipped', isFlipped);
            } else {
                // Si no existe, inicialízalo con isFlipped
                this.$set(this.cardState, cardId, { isFlipped });
            }
        },
    },
    created() {
        // Initialize cardState for each card
        this.cards.forEach(card => {
            this.$set(this.cardState, card.id, { isFlipped: false });
        });
        this.cards2.forEach(card2 => {
            this.$set(this.cardState, card2.id, { isFlipped: false });
        });
    },
    
};
</script>
<style>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
</style>